export const EDIT_CONTRACT_REQUESTED = 'EDIT_CONTRACT_REQUESTED';
export const EDIT_CONTRACT_SUCCEED = 'EDIT_CONTRACT_SUCCEED';
export const EDIT_CONTRACT_FAILED = 'EDIT_CONTRACT_FAILED';
export const REGISTER_CONTRACT_REQUESTED = 'REGISTER_CONTRACT_REQUESTED';
export const REGISTER_CONTRACT_SUCCEED = 'REGISTER_CONTRACT_SUCCEED';
export const REGISTER_CONTRACT_FAILED = 'REGISTER_CONTRACT_FAILED';
export const DELETE_CONTRACT_REQUESTED = 'DELETE_CONTRACT_REQUESTED';
export const DELETE_CONTRACT_SUCCEED = 'DELETE_CONTRACT_SUCCEED';
export const DELETE_CONTRACT_FAILED = 'DELETE_CONTRACT_FAILED';